export default __webpack_public_path__ + "static/media/uploadCover.21ed683b.png";